(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push();
  angular.module('MktzapApp.Controllers')
    .controller('BusinessManagementController', business)
  business.$inject = ['$rootScope', 'DashboardService', 'NotificationService', '$state'];
  function business ($rootScope, DashboardService, NotificationService, $state) {
    var vmBManCtrl = this;
    var geoChart = {};
    var columnChartUF = {};
    var pieChart = {};
    var pieChartOp = {};

    $rootScope.fullscreen = true;

    vmBManCtrl.favicon = {
      1: 'fa-envelope-o',
      2: 'fa-facebook-official',
      3: 'fa-mobile',
      4: 'fa-comment',
      5: 'fa-whatsapp',
      6: 'fa-paper-plane-o'
    };

    var options = function () {
      return {
        backgroundColor: 'none',
        colors: ['#05e41a', '#00ace4', '#e754ec', '#ffb30f'],
        vAxis: {
          titleTextStyle: { color: '#fff' },
          textStyle: { color: 'white' }
        },
        hAxis: {
          minValue: 0,
          titleTextStyle: { color: '#000' },
          textStyle: { color: 'white' }
        },
        legend: {
          textStyle: {
            color: 'white'
          },
          position: 'top'
        }
      };
    }

    var pieChartOptions = function () {
      return {
        backgroundColor: 'none',
        colors: ['#05e41a', '#00ace4', '#e754ec', '#ffb30f'],
        vAxis: {
          titleTextStyle: { color: '#fff' },
          textStyle: { color: 'white' }
        },
        hAxis: {
          minValue: 0,
          titleTextStyle: { color: '#000' },
          textStyle: { color: 'white' }
        },
        legend: {
          textStyle: {
            color: 'white'
          },
          position: 'top'
        },
        is3D: true
      };
    }

    geoChart.type = 'GeoChart';
    geoChart.options = {
      colorAxis: { colors: ['#aec7e8', '#1f77b4'] },
      displayMode: 'regions',
      region: 'BR',
      resolution: 'provinces',
      magnifyingGlass: { enable: true, zoomFactor: 8.5 },
      backgroundColor: 'none',
      tooltip: { isHtml: true }
    };
    vmBManCtrl.geoChartObject = geoChart;

    pieChart.type = 'PieChart';
    pieChart.options = pieChartOptions();
    vmBManCtrl.pieChartObject = pieChart;

    pieChartOp.type = 'PieChart';
    pieChartOp.options = pieChartOptions();
    vmBManCtrl.pieChartOpObject = pieChartOp;

    columnChartUF.type = 'ColumnChart';
    columnChartUF.options = options();
    columnChartUF.options.seriesType = 'bars';
    columnChartUF.options.series = { 2: { type: 'line' } };
    vmBManCtrl.columnChartUFObject = columnChartUF;

    vmBManCtrl.dates = {
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month')
    };

    vmBManCtrl.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    // Dashboard rotation
    if ($state.params.time) {
      var dash;
      if ($state.params.team) {
        dash = 'main.dashboard-team-management';
      } else if ($state.params.op) {
        dash = 'main.dashboard-operational-summary';
      }

      if ($state.params.from && $state.params.to) {
        vmBManCtrl.filters.fromDate = $state.params.from;
        vmBManCtrl.filters.toDate = $state.params.to;
      }

      setTimeout(function () {
        $state.go(dash, {
          time: $state.params.time,
          business: $state.params.business,
          team: $state.params.team,
          op: $state.params.op,
          from: vmBManCtrl.filters.fromDate,
          to: vmBManCtrl.filters.toDate
        });
        clearInterval(filterInterval);
        clearInterval(carouselInterval);
      }, $state.params.time);
    }

    vmBManCtrl.dateSelected = function (type, date) {
      var viewByMonth = document.getElementById('viewByMonth');
      var viewByDay = document.getElementById('viewByDay');
      viewByMonth.classList.remove('class', 'active');
      viewByDay.classList.remove('class', 'active');

      if (type == 'from') {
        vmBManCtrl.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vmBManCtrl.pkadayFromDate.setMaxDate(date);
      }
    };

    vmBManCtrl.details = function (datas) {
      var params = {};
      params.filters = vmBManCtrl.filters;
      $rootScope.fullscreen = false;
      $state.go('main.history', params);
    };

    DashboardService.loadFiltersBM()
      .$promise
      .then(function (data) {
        vmBManCtrl.companies = data.companies;
        vmBManCtrl.sectors = data.sectors;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorGetFilters);
      });

    vmBManCtrl.filterDatas = function () {
      DashboardService.filterBusinessManagement({
        filters: vmBManCtrl.filters
      })
        .$promise
        .then(function (data) {
          vmBManCtrl.counters = data.counters;
          vmBManCtrl.channels = data.channels;
          vmBManCtrl.channelsCount = (data.channels).length;

          var geoData = [[$rootScope.labels.states, $rootScope.labels.atts, { type: 'string', role: 'tooltip', 'p': { 'html': true } }]];
          var pieData = { cols: [
            { id: 't', label: $rootScope.labels.status, type: 'string' },
            { id: 's', label: $rootScope.labels.atts, type: 'number' }
          ],
          rows: [] };

          var pieDataOp = { cols: [
            { id: 't', label: $rootScope.labels.status, type: 'string' },
            { id: 's', label: $rootScope.labels.atts, type: 'number' }
          ],
          rows: [] };

          var columnDataUF = { cols: [
            { id: 't', label: $rootScope.labels.status, type: 'string' },
            { id: 's', label: $rootScope.labels.atts, type: 'number' },
            { id: 's', label: $rootScope.labels.finished, type: 'number' },
            { id: 's', label: $rootScope.labels.success, type: 'number' }
          ],
          rows: [] }

          angular.forEach(data.states, function (row, key) {
            geoData.push(['BR-' + row.UF, parseInt(row.atendimentos), '<strong>' + $rootScope.labels.ranking + ':</strong> ' + (key + 1) +
                                                                'º <br/><strong>' + $rootScope.labels.atts + ':</strong> ' + row.atendimentos +
                                                                '<br/><strong>' + $rootScope.labels.success + ':</strong> ' + (row.perc ? row.perc : 0) + '%']);
            if (key <= 7) {
              columnDataUF.rows.push({ c: [
                { v: row.UF },
                { v: parseInt(row.atendimentos) },
                { v: parseInt(row.finalizados) },
                { v: parseInt(row.sucesso) }
              ] });
            }
          });

          angular.forEach(data.statuschart, function (row, key) {
            pieData.rows.push({ c: [{ v: row.name.trim() }, { v: parseInt(row.atendimentos) }] });
          });

          angular.forEach(data.operationalchart, function (row, key) {
            pieDataOp.rows.push({ c: [{ v: row.name.trim() }, { v: parseInt(row.atendimentos) }] });
          });

          geoChart.data = geoData;
          columnChartUF.data = columnDataUF;
          pieChart.data = pieData;
          pieChartOp.data = pieDataOp;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorGetInfo);
        });
    }

    vmBManCtrl.autocomplete = function (term) {
      var filter = [];
      var rgex = new RegExp(term.toLowerCase());
      vmBManCtrl.sectors.map(function (person) {
        if (person.name.toLowerCase().match(rgex)) {
          filter.push(person);
        }
      });
      return filter;
    }

    vmBManCtrl.filterByDay = function () {
      vmBManCtrl.filters = {
        fromDate: moment().format('DD/MM/YYYY'),
        toDate: moment().format('DD/MM/YYYY')
      };
      vmBManCtrl.filterDatas();

      var viewByDay = document.getElementById('viewByDay');
      viewByDay.setAttribute('class', 'active');
      var viewByMonth = document.getElementById('viewByMonth');
      viewByMonth.classList.remove('class', 'active');
    }

    vmBManCtrl.filterByMonth = function () {
      vmBManCtrl.filters = {
        fromDate: moment().startOf('month').format('DD/MM/YYYY'),
        toDate: moment().endOf('month').format('DD/MM/YYYY')
      };
      vmBManCtrl.filterDatas();

      var viewByMonth = document.getElementById('viewByMonth');
      viewByMonth.setAttribute('class', 'active');
      var viewByDay = document.getElementById('viewByDay');
      viewByDay.classList.remove('class', 'active');
    }

    vmBManCtrl.toggleFilters = function () {
      var div = document.getElementById('filters_info');
      if (div.style.display === 'none') {
        div.style.display = 'block';
      } else {
        div.style.display = 'none';
      }
    }

    vmBManCtrl.carousel = function () {
      var slide0 = document.getElementById('slide_0');
      var slide1 = document.getElementById('slide_1');
      if (!slide0.classList.contains('active')) {
        slide0.click();
      } else {
        slide1.click();
      }
    }

    vmBManCtrl.filterDatas();
    var filterInterval = setInterval(function () {
      vmBManCtrl.filterDatas();
    }, 60000);

    var carouselInterval = setInterval(function () {
      vmBManCtrl.carousel();
    }, 10000);
  }
})();
